import React from 'react';
import {Img} from './styles'
import styled from 'styled-components';

type AnswerImgProps = {
    src: string;
    isDisabled?: boolean;
    isSelected?: boolean;
}

type WrapTypes = {
    isDisabled?: boolean;
    isSelected?: boolean;
}

const Wrap = styled.div<WrapTypes>`
    ${({ isDisabled, isSelected }) => (isDisabled && !isSelected)  && `
       opacity: 0.5;
    `}
`;

const AnswerImg: React.FC<AnswerImgProps> = ({ src, isDisabled, isSelected }) => {
    const isSvg = src.endsWith('.svg');

    return (
        <Wrap isDisabled={isDisabled} isSelected={isSelected}>
            <Img
                src={src}
                alt=""
                isSvg={isSvg}
            />
        </Wrap>
    );
};

export default AnswerImg;